import { render, staticRenderFns } from "./GuidArea.vue?vue&type=template&id=5f669ae7&scoped=true&"
import script from "./GuidArea.vue?vue&type=script&lang=js&"
export * from "./GuidArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f669ae7",
  null
  
)

export default component.exports